//#region IMPORT
import React from 'react';
/** Components Import */
import { Box, Stack, Typography } from '@mui/material';
import { Button, Dialog } from '../../../../Components/MUIs';
import ReactPlayer from 'react-player/lazy';
/** Icons Import */
import { Group as GroupIcon } from '@mui/icons-material';
import Lottie from 'lottie-react';
import AiAnimation from '../../../../Assets/animations/Loading.json';
//#endregion

function M_TBM_CUSTOM_02(props) {
  return (
    <>
      <Stack sx={{ display: 'flex', alignItems: 'start', m: 2, mt: 0 }}>
        <Typography sx={{ fontSize: '18px', fontWeight: 'bold' }}>
          영상 교육
        </Typography>
        <Typography sx={{ color: '#828282' }}>
          영상을 재생하여 교육을 시작해주세요.
        </Typography>
      </Stack>
      {!props.inputs.video ? (
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          width="100%"
          height="60vh"
        >
          <Typography variant="h5" fontWeight={550}>
            등록된 동영상이 없습니다.
          </Typography>
          <Typography variant="body1">관리자에게 문의하세요.</Typography>
        </Box>
      ) : (
        <Box sx={{ bgcolor: '#000000' }}>
          <ReactPlayer
            ref={props.videoRef}
            url={props.inputs.video}
            width="100%"
            height="40vh"
            controls={true}
            onEnded={props.HandleVideoEnd}
            onProgress={props.HandleProgress}
            onSeek={props.HandleSeek}
            onError={(e) => props.HandleVideoError(e)}
            progressInterval={100} // 100ms마다 onProgress 호출
            playing={props.play}
          />
        </Box>
      )}
      <Stack
        sx={{
          p: 2,
          mt: 2,
          display: 'flex',
          justifyContent: 'space-between',
          alignContent: 'center',
        }}
        direction={'row'}
        spacing={3}
      >
        <Button
          sx={{
            width: '100%',
            height: '36px',
            borderRadius: '18px',
          }}
          // disabled={!props.inputs.isNext}
          name="완료"
          onClick={() => {
            props.ActiveButton({
              type: 'check1', // 동영상교육 완료
              id: props.userInfo.userid,
              content: true,
            });
            props.setModalToggle1(true);
          }}
        />
      </Stack>
      {/* 근로자가 완료한 경우 */}
      {props.modalToggle1 && (
        <Dialog
          open={props.modalToggle1}
          onClose={(e) => props.setModalToggle1(false)}
          sx={{ height: '90vh' }}
          titleSx={{
            fontSize: '14px',
            fontWeight: 'bold',
            color: '#D9D9D9',
            pt: 3,
            pb: 1.5,
          }}
          contentSx={{ display: 'flex', flexDirection: 'column', p: 3, px: 3 }}
          actionsSx={{ p: 0 }}
          PaperProps={{
            sx: {
              m: 2,
              borderRadius: 4,
              width: 'calc(100% - 32px)', // 좌우 마진 고려한 전체 너비
              maxWidth: '100%', // 혹시 모를 제한 제거
            },
          }}
          fullWidth={true}
          saveButtonName={
            props.lanList.length === 0
              ? ''
              : props.lanList.find(
                (f) => f.lanType === 'CALL' && f.lanId === 'Choice'
              ).lanNm
          } //선택
          closeButtonName={
            props.lanList.length === 0
              ? ''
              : props.lanList.find(
                (f) => f.lanType === 'CALL' && f.lanId === 'Close'
              ).lanNm
          } //닫기
          useSaveButton={false}
          useSaveAfterClose={false}
          useCloseButton={false}
          onSave={() => { }}
          maxWidth={false}
          content={
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <Lottie
                animationData={AiAnimation}
                loop
                autoplay
                style={{
                  display: 'flex',
                  width: '50px',
                  height: '30px',
                  overflow: 'hidden',
                  transform: 'scale(4)',
                }}
              />
              <Box>
                <Typography sx={{ fontSize: '18px', fontWeight: 'bold' }}>
                  현재 입장 대기중입니다.
                </Typography>
                <Typography>잠시 대기해주세요.</Typography>
                <Typography>관리자가 교육 시작 시 진행됩니다.</Typography>
              </Box>
              <Box
                sx={{
                  pt: 2,
                  gap: 0.5,
                  display: 'flex',
                  justifyContent: 'start',
                  alignContent: 'center',
                }}
              >
                <GroupIcon />
                <Typography>
                  {/* 현재 100명 중{" "} */}
                  <Typography
                    component="span"
                    fontWeight="bold"
                    sx={{ color: '#00789E' }}
                  >
                    {
                      props.check.filter((item) => item.type === 'check1')
                        .length
                    }
                    명
                  </Typography>{' '}
                  참가 완료
                </Typography>
              </Box>
            </Box>
          }
        />
      )}
      {/* 관리자가 완료한 경우 */}
      {props.modalToggle2 && (
        <Dialog
          open={props.modalToggle2}
          // onClose={(e) => props.setModalToggle1(false)}
          sx={{ height: '90vh' }}
          titleSx={{
            fontSize: '14px',
            fontWeight: 'bold',
            color: '#D9D9D9',
            pt: 3,
            pb: 1.5,
          }}
          contentSx={{ display: 'flex', flexDirection: 'column', p: 3, px: 3 }}
          actionsSx={{ p: 0 }}
          PaperProps={{
            sx: {
              m: 2,
              borderRadius: 4,
              width: 'calc(100% - 32px)', // 좌우 마진 고려한 전체 너비
              maxWidth: '100%', // 혹시 모를 제한 제거
            },
          }}
          fullWidth={true}
          saveButtonName="선택"
          closeButtonName="닫기"
          useSaveButton={false}
          useSaveAfterClose={false}
          useCloseButton={false}
          onSave={() => { }}
          maxWidth={false}
          content={
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <Lottie
                animationData={AiAnimation}
                loop
                autoplay
                style={{
                  display: 'flex',
                  width: '50px',
                  height: '30px',
                  overflow: 'hidden',
                  transform: 'scale(4)',
                }}
              />
              <Box>
                <Typography sx={{ fontSize: '18px', fontWeight: 'bold' }}>
                  다음 단계로 진행됩니다.
                </Typography>
                <Typography>관리자가 동영상 교육을 마쳤습니다.</Typography>
                <Typography>잠시 후 교육자료를 학습해주세요.</Typography>
              </Box>
              <Box
                sx={{
                  pt: 2,
                  gap: 0.5,
                  display: 'flex',
                  justifyContent: 'start',
                  alignContent: 'center',
                }}
              >
                <GroupIcon />
                <Typography>
                  {/* 현재 100명 중{" "} */}
                  <Typography
                    component="span"
                    fontWeight="bold"
                    sx={{ color: '#00789E' }}
                  >
                    {
                      props.check.filter((item) => item.type === 'check1')
                        .length
                    }
                    명
                  </Typography>{' '}
                  참가 완료
                </Typography>
              </Box>
            </Box>
          }
        />
      )}
    </>
  );
}

export default M_TBM_CUSTOM_02;
